export default {"src":"/_next/static/media/3.64e25bc6.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};